import React from "react";
import {H1} from "../../../elements/Heading";

const PageTitle = () => {
    return <H1>Marketplace Beta</H1>;
};

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/model/PageTitle/index.tsx